import * as Yup from 'yup';

const requiredMessage = 'Required';

export const schemaValidation = Yup.object().shape({
  oldPassword: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  newPassword: Yup.string().trim().nullable(requiredMessage).required(requiredMessage),
  confirmPassword: Yup.string()
    .trim()
    .nullable(requiredMessage)
    .required(requiredMessage)
    .oneOf([Yup.ref('newPassword'), null], 'Not match'),
});
